import Vue from 'vue'
import router from './router'
import store from './vuex/store'
import App from './App.vue'
import Codium from '@codium/codium-vue'
import Chameleon from '@chameleon/chameleon-vue'
import PortalVue from 'portal-vue'

/**
 * Import other dependencies.
 */
import '@/mixins'
import '@/filters'
import '@/utils/font-awesome'
import configureValidation from '@/utils/validation'
import '@/utils/components'
import 'bootstrap'

/**
 * Import Prism styles for syntax highlighting(code snippets).
 */
import 'prismjs/themes/prism-tomorrow.min.css'

/**
 * Import theme SCSS.
 */
import 'vue-multiselect/dist/vue-multiselect.min.css'
import '@/assets/scss/app.scss'

Vue.config.productionTip = false

Vue.use(Codium)
Vue.use(Chameleon)
Vue.use(PortalVue)

configureValidation()

const applyTheme = mode => {
  document.documentElement.setAttribute('data-theme', mode)
}

applyTheme(store.get('theme/mode'))
store.watch(
  (state, getters) => store.get('theme/mode'),
  mode => applyTheme(mode)
)

export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
